// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { ForgotPassword as ForgotPasswordUI } from 'ui_kit_qmd'
import { reset } from '../../store/forgot-password/ForgotPasswordActions'
import { resetPassword } from '../../store/forgot-password/ForgotPasswordThunk'
import { validateEmail } from '../../utils/common'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { ProviderPage } from '../../components/provider-page/ProviderPage'

export default function ForgotPassword() {
  const [emailValue, setEmailValue] = useState('')
  const [emailError, setEmailError] = useState('')
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.forgotPassword.loading)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const resetSuccess = useSelector((state) => state.forgotPassword.resetSuccess)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loginSuccess = useSelector((state) => state.auth.accessToken)

  const dispatch = useDispatch()
  const navigate = useNavigate()
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetEmail = useCallback((value) => {
    setEmailValue(value)
    setEmailError('')
  }, [])

  const onBackToLogin = useCallback(() => {
    navigate('/')
    dispatch(reset())
  }, [dispatch, navigate])

  const onPrimaryClick = useCallback(() => {
    if (resetSuccess) {
      navigate('/')
      dispatch(reset())
      return
    }
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setEmailError(false)
    let isError = false
    if (!emailValue) {
      isError = true
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setEmailError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Email'))
    } else if (!validateEmail(emailValue)) {
      isError = true
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setEmailError(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'email'))
    }
    if (!isError) {
      dispatch(resetPassword({ Email: emailValue }))
    }
  }, [dispatch, emailValue, navigate, resetSuccess])

  useEffect(() => {
    dispatch(reset())
  }, [dispatch])

  useEffect(() => {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const handleEnterPressEvent = (e) => {
      if (e.key === 'Enter') {
        onPrimaryClick()
      }
    }
    window.addEventListener('keyup', handleEnterPressEvent)
    return () => window.removeEventListener('keyup', handleEnterPressEvent)
  }, [emailValue, onPrimaryClick])

  useEffect(() => {
    if (loginSuccess) {
      navigate('/management')
    }
  }, [loginSuccess, navigate])

  return (
    // @ts-expect-error TS2740 -- MIGRATION: not approved, fix when encountered
    <ProviderPage
      isLoginPage
      loading={loading}
      render={
        <ForgotPasswordUI
          emailError={emailError}
          emailValue={emailValue}
          resetSuccess={resetSuccess}
          onSetEmail={onSetEmail}
          onBackToLogin={onBackToLogin}
          onPrimaryClick={onPrimaryClick}
        />
      }
    />
  )
}
